import BpkButton, {
  BUTTON_TYPES,
} from '@skyscanner-internal/backpack-web/bpk-component-button';
import BpkCard from '@skyscanner-internal/backpack-web/bpk-component-card';
import { withRtlSupport } from '@skyscanner-internal/backpack-web/bpk-component-icon';
import ArrowIcon from '@skyscanner-internal/backpack-web/bpk-component-icon/sm/long-arrow-right';
import {
  BpkBreakpoint,
  BpkSpacing,
  BpkStack,
  BpkVessel,
} from '@skyscanner-internal/backpack-web/bpk-component-layout';
import BpkText from '@skyscanner-internal/backpack-web/bpk-component-text';

import buildUrl from '../urlBuilder';

import STYLES from './NoDeals.module.scss';

const RtlArrowIcon = withRtlSupport(ArrowIcon);

type NoDealsProps = {
  destinationCode?: string;
  noDealsCtaText: string;
  noDealsTipsText: string;
  originCode: string;
};

const NoDeals = ({
  destinationCode = '',
  noDealsCtaText,
  noDealsTipsText,
  originCode,
}: NoDealsProps) => {
  const urlParams =
    destinationCode === 'ANYWHERE'
      ? { originId: originCode, date: 'anytime' }
      : {
          originId: originCode,
          date: 'anytime',
          destinationId: destinationCode,
        };
  const browseUrl = buildUrl(urlParams);

  return (
    <BpkCard className={STYLES.NoDeals} padded={false}>
      <BpkVessel className={STYLES.NoDeals__content}>
        <BpkStack
          direction={{ base: 'column', [BpkBreakpoint.SmallTablet]: 'row' }}
          gap={BpkSpacing.None}
        >
          <BpkText className={STYLES.NoDeals__text}>{noDealsTipsText}</BpkText>
          <BpkButton
            className={STYLES.NoDeals__button}
            href={browseUrl}
            rel="nofollow"
            type={BUTTON_TYPES.secondary}
          >
            {noDealsCtaText}
            &nbsp;
            <RtlArrowIcon />
          </BpkButton>
        </BpkStack>
      </BpkVessel>
    </BpkCard>
  );
};

export default NoDeals;
